const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;

if (ScrollTrigger) {
    try {
        gsap.registerPlugin(ScrollTrigger);
    } catch (e) {}
}

const inited = new WeakSet();
const toChars = (s) => Array.from(String(s ?? ""));
const isDebug = () =>
    !!window.__DEBUG ||
    /[?&]debug=1/.test(location.search) ||
    document.body?.dataset?.debug === "1" ||
    document.documentElement.classList.contains("debug");

export default function initTeamOverview(sectionSel = ".team-overview", textSel = ".ov-text") {
    const sections = document.querySelectorAll(sectionSel);
    if (!sections.length) {
        if (isDebug()) console.warn('[overview] no sections for', sectionSel);
        return;
    }
    sections.forEach((section) => {
        if (inited.has(section)) return;

        const p = section.querySelector(textSel);
        if (!p) {
            if (isDebug()) console.warn('[overview] no text node for', textSel, 'in', section);
            return;
        }

        if (!p.dataset.typed) {
            const src = p.innerHTML.trim();
            const tmp = document.createElement("div");
            tmp.innerHTML = src;
            const frag = document.createDocumentFragment();

            const walk = (node, parent) => {
                if (node.nodeType === Node.TEXT_NODE) {
                    const norm = node.textContent.replace(/\s+/g, " ");
                    for (const ch of toChars(norm)) {
                        if (ch === " ") parent.appendChild(document.createTextNode(" "));
                        else {
                            const s = document.createElement("span");
                            s.className = "ov-ch";
                            s.textContent = ch;
                            parent.appendChild(s);
                        }
                    }
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.tagName === "B" || node.tagName === "STRONG") {
                        const b = document.createElement("b");
                        b.textContent = node.textContent.replace(/\s+/g, " ");
                        parent.appendChild(b);
                    } else if (node.tagName === "BR") {
                        parent.appendChild(document.createElement("br"));
                    } else {
                        node.childNodes.forEach((c) => walk(c, parent));
                    }
                }
            };

            // важливо: обходимо дітей tmp, а не сам контейнер
            tmp.childNodes.forEach((n) => walk(n, frag));
            p.innerHTML = "";
            p.appendChild(frag);
            p.dataset.typed = "1";
        }

        const muted = getComputedStyle(section).getPropertyValue("--muted")?.trim() || "#878c91";
        const allChars = Array.from(p.querySelectorAll(".ov-ch"));
        if (!allChars.length) return;

        // беремо символи після першого <b>
        const firstBold = p.querySelector("b");
        let tailChars = allChars;
        if (firstBold) {
            const afterBold = [];
            let passed = false;
            p.childNodes.forEach((node) => {
                if (node === firstBold) { passed = true; return; }
                if (!passed) return;
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.classList?.contains("ov-ch")) afterBold.push(node);
                    else afterBold.push(...(node.querySelectorAll?.(".ov-ch") || []));
                }
            });
            if (afterBold.length) tailChars = afterBold;
        }

        gsap.set(allChars, { opacity: 0, color: muted });

        const tl = gsap.timeline({ paused: true });
        tl.to(tailChars, { opacity: 1, stagger: { each: 0.02 }, duration: 0.4, ease: "power1.out" });

        ScrollTrigger.create({
            trigger: section,
            start: "top 90%",
            once: true,
            onEnter: () => tl.play()
        });

        inited.add(section);
        if (isDebug()) console.log('[overview] inited:', sectionSel, '→ chars:', allChars.length);
    });
}
